import useMediaQuery from "./useMediaQuery"

function useMobile() {
  return useMediaQuery(`(max-width: 800px)`)
}

export default useMobile
